import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import PeopleBody from "components/CompaniesComponents/CompanyDetails/CompanyPeoples/PeopleBody/PeopleBody";

const CompanyPeoples = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Clinics";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="companies" />

      {/* ------ body section --------- */}
      <PeopleBody />
    </main>
  );
};

export default CompanyPeoples;
